// Event type translations and utilities
export const eventTypeTranslations = {
  MEETING: "Réunion",
  VACATION: "Vacance",
  BANK_HOLIDAY: "Jour férié",
  OTHER: "Inconnu",
};

export const eventTypePluralTranslations = {
  MEETING: "Réunions",
  VACATION: "Vacances",
  BANK_HOLIDAY: "Jours fériés",
  OTHER: "Autres",
};

export const eventIcons = {
  MEETING: "pi pi-calendar",
  VACATION: "pi pi-send",
  BANK_HOLIDAY: "pi pi-flag",
  OTHER: "pi pi-question",
};

export const eventColors = {
  MEETING: "#673ab7",
  VACATION: "#0ea5e9",
  BANK_HOLIDAY: "#ef4444",
  OTHER: "gray",
};

// Calculate if an event spans multiple days
export const calculateDaysBetween = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const timeDiff = endDate - startDate;
  const daysDiff = timeDiff / (1000 * 3600 * 24); // Convert from ms to days
  return daysDiff;
};

// Get the appropriate translation (singular or plural) based on event duration
export const getEventTypeTranslation = (eventType, startDate, endDate) => {
  const isMultiDay = calculateDaysBetween(startDate, endDate) > 0;
  return isMultiDay 
    ? eventTypePluralTranslations[eventType] 
    : eventTypeTranslations[eventType];
};

// Get event type display properties for Tag component
export const getEventTypeDisplayProps = (eventType, startDate, endDate) => {
  const translatedEventType = getEventTypeTranslation(eventType, startDate, endDate);
  const tagColor = eventColors[eventType] || "gray";
  const iconClass = eventIcons[eventType] || "pi pi-info";

  return {
    value: translatedEventType || eventType,
    icon: iconClass,
    style: { backgroundColor: tagColor, width: '150px' }
  };
};
